import { useEffect } from 'react';

function isEditableElement(element) {
  if (!(element instanceof HTMLElement)) return false;

  const tagName = element.tagName.toLowerCase();
  return (
    element.isContentEditable
    || tagName === 'input'
    || tagName === 'textarea'
    || tagName === 'select'
    || element.getAttribute('role') === 'textbox'
    || element.getAttribute('role') === 'combobox'
  );
}

function isInsideRef(ref) {
  return Boolean(ref?.current && ref.current.contains(document.activeElement));
}

export function useOperationalShortcuts({
  enabled = true,
  isSubmitting = false,
  isGuidesModalOpen = false,
  isEmitModalOpen = false,
  isOverrideModalOpen = false,
  isChoferModalOpen = false,
  isVehiculoModalOpen = false,
  selectedLinea = '',
  requireSelectedLineaForGuides = true,
  primaryAction = null,
  onOpenGuides = null,
  onConfirmEmit = null,
  onOpenChoferQuickCreate = null,
  onOpenVehiculoQuickCreate = null,
  onBlockedShortcut = null,
  choferContextRef = null,
  vehiculoContextRef = null,
}) {
  useEffect(() => {
    if (!enabled) return undefined;

    const hasBlockingModal = isGuidesModalOpen || isOverrideModalOpen || isChoferModalOpen || isVehiculoModalOpen;

    const handleKeyDown = (event) => {
      if (event.defaultPrevented) return;
      if (event.repeat && ['F2', 'F5', 'F7'].includes(event.key)) return;

      const target = event.target;
      const isTextEntry = isEditableElement(target);

      if (event.key === 'F5') {
        if (isEmitModalOpen) {
          event.preventDefault();
          if (!isSubmitting) onConfirmEmit?.();
          return;
        }

        if (hasBlockingModal || isTextEntry) {
          return;
        }

        if (primaryAction?.disabled) {
          event.preventDefault();
          onBlockedShortcut?.(primaryAction?.title || 'Complete los datos requeridos antes de emitir.');
          return;
        }

        event.preventDefault();
        primaryAction?.onClick?.();
        return;
      }

      if (event.key === 'F2') {
        if (hasBlockingModal || isEmitModalOpen) return;

        event.preventDefault();
        if (requireSelectedLineaForGuides && !selectedLinea) {
          onBlockedShortcut?.('Seleccione una linea para habilitar guias.');
          return;
        }

        onOpenGuides?.();
        return;
      }

      if (event.key === 'F7') {
        if (hasBlockingModal || isEmitModalOpen) return;

        const inChoferContext = isInsideRef(choferContextRef);
        const inVehiculoContext = isInsideRef(vehiculoContextRef);

        if (inChoferContext) {
          event.preventDefault();
          onOpenChoferQuickCreate?.();
          return;
        }

        if (inVehiculoContext) {
          event.preventDefault();
          onOpenVehiculoQuickCreate?.();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [
    choferContextRef,
    enabled,
    isChoferModalOpen,
    isEmitModalOpen,
    isGuidesModalOpen,
    isOverrideModalOpen,
    isSubmitting,
    isVehiculoModalOpen,
    onBlockedShortcut,
    onConfirmEmit,
    onOpenChoferQuickCreate,
    onOpenGuides,
    onOpenVehiculoQuickCreate,
    primaryAction,
    requireSelectedLineaForGuides,
    selectedLinea,
    vehiculoContextRef,
  ]);
}

export default useOperationalShortcuts;
